import { useEffect, useRef, useMemo } from "react"
import axios from "axios"
import APP_STATE from "constants/appState"
import useRefreshToken from "utilities/useRefreshToken"
import useAuth from "context/hooks/useAuth" // apis
import { getCookie } from "api/apiUtils"
import { ACCESS_TOKEN_KEY } from "constants/appState.js"

// context
import useAppState from "context/hooks/useAppState"

const useAxiosPrivate = () => {
  const { setTokens, refreshTokens } = useRefreshToken()

  const { appStateRef } = useAppState()
  const { auth } = useAuth()

  useEffect(() => {
    const requestIntercept = axios.interceptors.request.use(
      async (config) => {
        let accessToken = getCookie(ACCESS_TOKEN_KEY)
        let loginIdp = getCookie("LOGIN_IDP") || null

        if (accessToken) {
          config.headers["Authorization"] = `Bearer ${accessToken}`
          config.headers["LOGIN_IDP"] = loginIdp
          config.headers["Cache-Control"] = "no-store, no-cache, must-revalidate, max-age=0"
          config.credentials = "include"
        }

        return config
      },
      (error) => Promise.reject(error)
    )

    const responseIntercept = axios.interceptors.response.use(
      (response) => response,
      async (error) => {
        const prevRequest = error?.config

        if (
          (error.response?.data?.error?.status_code === 401 || error?.response?.status === 401) &&
          prevRequest._retry !== true &&
          !prevRequest?.url?.includes("/auth/api/v1/login/")
        ) {
          if (appStateRef?.current !== APP_STATE?.refresh || !appStateRef.current === undefined) {
            let tokens = await refreshTokens()

            setTokens(tokens)
            prevRequest._retry = true
          }
          await new Promise((r) => setTimeout(r, 500))
          return axios(prevRequest)
        }

        return Promise.reject(error)
      }
    )

    return () => {
      axios.interceptors.request.eject(requestIntercept)
      axios.interceptors.response.eject(responseIntercept)
    }
  }, [auth, refreshTokens])

  return axios
}

export default useAxiosPrivate
